export const ConsultationQ1EmailCaptureOptimizationAbTestVariantA = 'A';
export const ConsultationQ1EmailCaptureOptimizationAbTestVariantB = 'B';
export const ConsultationQ1EmailCaptureOptimizationAbTestVariantC = 'C';
